<div class="partners block">
  <div class="heading heading_standard heading_centered">
    They use image base
  </div>
  <div class="they-use-image-base partners__items">
    <owl-carousel-o [options]="owlOptions">
      @for (item of carouselItems; track item.name) {
        <ng-template carouselSlide>
          <div class="partners__item">
            <img
              [src]="item.logo.url"
              [width]="item.logo.width"
              [height]="item.logo.height"
              [alt]="item.name"
            />
          </div>
        </ng-template>
      }
    </owl-carousel-o>
  </div>
</div>
